// Shared bits for the client collab-marketplace screens.
import { User } from "lucide-react";

export function CoachAvatars({ coaches = [], size = 36, max = 3 }) {
  const shown = coaches.slice(0, max);
  const extra = coaches.length - max;
  return (
    <div className="flex items-center" style={{ height: size }}>
      {shown.map((c, i) => {
        const raw = (c.name || "").trim();
        const initial = /^[\p{L}\p{N}]/u.test(raw) ? raw[0].toUpperCase() : null;
        return (
          <span key={c.id || i} className="flex items-center justify-center overflow-hidden rounded-full border-2 border-background bg-primary/20 text-xs font-semibold text-primary"
            style={{ width: size, height: size, marginLeft: i === 0 ? 0 : -size / 4 }}>
            {c.photo ? <img src={c.photo} alt={c.name || ""} className="h-full w-full object-cover" />
              : initial ? initial
              : <User className="text-primary" style={{ width: size * 0.5, height: size * 0.5 }} />}
          </span>
        );
      })}
      {extra > 0 ? (
        <span className="flex items-center justify-center rounded-full border-2 border-background bg-primary/15 text-[11px] font-semibold text-primary"
          style={{ width: size, height: size, marginLeft: -size / 4 }}>+{extra}</span>
      ) : null}
    </div>
  );
}
